var map = {
	"./bg_01.png": "ffc3",
	"./bg_02.png": "06c1",
	"./bg_03.png": "6022",
	"./bg_04.png": "0d95",
	"./bg_05.png": "4d03",
	"./bg_06.png": "b629",
	"./云.png": "6e9f",
	"./人.png": "e2de",
	"./冰淇淋车.png": "80c8",
	"./冰淇淋车男孩.png": "f0c2",
	"./单车-点击业务.png": "f96e",
	"./印章.png": "1445",
	"./吹泡泡的小孩.png": "55d1",
	"./喝水.png": "5662",
	"./喷泉.png": "b95a",
	"./图层 227.png": "3c8a",
	"./图层 229 拷贝.png": "42c6",
	"./女孩(2).png": "a907",
	"./女孩+糖果.png": "4d90",
	"./女孩2.png": "3d46",
	"./女孩3.png": "17c7",
	"./小兔子女孩.png": "42d7",
	"./小朋友.png": "1819",
	"./小熊.png": "edaa",
	"./小狗.png": "cf78",
	"./帐篷.png": "fd7b",
	"./彩蛋.png": "454c",
	"./手指.png": "8754",
	"./手推车.png": "8afd",
	"./拍照妈妈.png": "e897",
	"./摩天轮.png": "f359",
	"./摩天轮下的男孩.png": "f396",
	"./旋转木马.png": "2187",
	"./旋转木马母亲(1).png": "fe67",
	"./旋转木马母亲.png": "9fff",
	"./旋转木马男孩.png": "b759",
	"./曲线 1.png": "ab56",
	"./母亲.png": "2e00",
	"./泡泡.png": "39b7",
	"./滑梯.png": "9e18",
	"./热气球.png": "716f",
	"./父亲拿包.png": "d50a",
	"./爸爸.png": "4c70",
	"./爸爸带孩子.png": "7bf2",
	"./猫(2).png": "5725",
	"./猫.png": "1fd0",
	"./玩偶.png": "f75b",
	"./玩玩具.png": "125f",
	"./男孩1.png": "a6af",
	"./男孩3.png": "24e6",
	"./男孩4.png": "0690",
	"./红色的气球.png": "c103",
	"./组 2.png": "0e15",
	"./舞台小丑表演.png": "5d6d",
	"./花草_01.png": "df03",
	"./花草_02.png": "9ffa",
	"./花草_03.png": "1c66",
	"./花草_04.png": "9cd0",
	"./花草_05.png": "8175",
	"./花草_06.png": "89fb",
	"./野餐.png": "7f85",
	"./长椅.png": "bb69",
	"./风筝 2.png": "af44",
	"./风筝.png": "5254",
	"./骑单车.png": "a878"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91d7";